// import { ApplicationInsights } from '@microsoft/applicationinsights-web';
// import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
// import { createBrowserHistory } from 'history';

// const browserHistory = createBrowserHistory();
// const reactPlugin = new ReactPlugin();
// const appInsights = new ApplicationInsights({
//     config: {
//         instrumentationKey: process.env.REACT_APP_APPINSIGHTS_KEY,
//         enableAutoRouteTracking: true,
//         autoTrackPageVisitTime: true,
//         extensions: [reactPlugin],
//         extensionConfig: {
//           [reactPlugin.identifier]: { history: browserHistory }
//         }
//     }
// });
// appInsights.loadAppInsights();
// export { reactPlugin, appInsights };

// Temporary mock exports - criar mock object para evitar erros quando withAITracking tenta usar
const createMockPlugin = () => ({
    trackMetric: () => {},
    trackEvent: () => {},
    trackException: () => {},
    trackTrace: () => {},
    trackPageView: () => {},
    trackDependencyData: () => {},
    identifier: 'mock-react-plugin'
});

export const reactPlugin = createMockPlugin();
export const appInsights = null;